(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-template"]) return;
  try {
    
  // Per-card swipe to reveal the second product image on touch devices used to
  // live here, delegated on #Huratips-Loop — but this section's own javascript
  // block only loads on pages that render this section, so it silently never ran
  // on templates/search.liquid (which also renders snippets/luxury-product-card.liquid,
  // for its own results grid) and had no #Huratips-Loop element anyway. Moved to
  // assets/theme.js (loaded site-wide) delegated on document instead, so it works
  // for this card wherever it's rendered, now or in the future.

  (function () {
    // Keeps --sticky-header-h in sync with the actual rendered height of whichever
    // luxury-header bar goes position:fixed on scroll at the CURRENT viewport width
    // (see setupFixedBar in sections/luxury-header.liquid): .lh-nav on desktop
    // (>=990px, inside .lh-desktop-only), .lh-mobile-sticky below that (inside
    // .lh-mobile-only) — the two bars differ in height, so measuring the wrong one
    // would push the sticky sidebar/results-row offset off by a visible amount.
    // Guarded against writing 0px: the non-active bar sits inside a display:none
    // wrapper at the current width, so measuring it returns 0 — writing that would
    // break the CSS var(--sticky-header-h, 60px) fallback for our sticky rules.
    function measureStickyHeaderOffset() {
      var bar = window.innerWidth >= 990
        ? document.querySelector('.lh-nav')
        : document.querySelector('.lh-mobile-sticky');
      if (!bar) return;
      var height = bar.getBoundingClientRect().height;
      if (height > 0) {
        document.documentElement.style.setProperty('--sticky-header-h', height + 'px');
      }
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', measureStickyHeaderOffset);
    } else {
      measureStickyHeaderOffset();
    }

    window.addEventListener('resize', debounce(measureStickyHeaderOffset, 150));

    var scrollThrottled = false;
    window.addEventListener('scroll', function () {
      if (scrollThrottled) return;
      scrollThrottled = true;
      setTimeout(function () {
        measureStickyHeaderOffset();
        scrollThrottled = false;
      }, 200);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-template"]) return;
  try {
    
$( '[data-fancybox="images"]' ).fancybox({
	infobar: false,
	animationEffect: "zoom",
	toolbar: "auto",
	transitionEffect: "fade",
    clickContent: function(current, event) {
        return current.type === "image" ? "zoom" : false;
  },
btnTpl: {
	close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" data-svg="close-icon"><line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line><line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line></svg>' +
      "</button>",
 
    arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><svg width="14px" height="24px" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg" data-svg="slidenav-previous"><polyline fill="none" stroke="#000" stroke-width="1.4" points="12.775,1 1.225,12 12.775,23 "></polyline></svg></div>' +
      "</button>",

    arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><svg width="14px" height="24px" viewBox="0 0 14 24" xmlns="http://www.w3.org/2000/svg" data-svg="slidenav-next"><polyline fill="none" stroke="#000" stroke-width="1.4" points="1.225,23 12.775,12 1.225,1 "></polyline></svg></div>' +
      "</button>",

},
    buttons : [
        'close'
    ],
});
$( '[data-fancybox="preview"]' ).fancybox({
	infobar: false,
	arrows: false,
	animationEffect: "zoom",
	transitionEffect: "fade",
	toolbar: "auto",
    mobile: {
    preventCaptionOverlap: false,
    idleTime: false,
    
  },
    buttons : [
		'zoom',
        'close'
    ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
    function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

    qsa('[data-lf-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        btn.setAttribute('aria-expanded', String(!expanded));
        var icon = qs('[data-lf-accordion-icon]', btn);
        if (icon) icon.textContent = expanded ? '+' : '−';
        if (panel) panel.hidden = expanded;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-header"]) return;
  try {
    
  (function () {
    function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
    function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

    var menu = qs('[data-lh-menu]');
    var overlay = qs('[data-lh-menu-overlay]');
    var searchPanel = qs('[data-lh-search-panel]');

    function openMenu() {
      if (!menu) return;
      menu.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      qsa('[data-lh-menu-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    }

    function closeMenu() {
      if (!menu) return;
      menu.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      qsa('[data-lh-menu-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () {
        if (!menu.classList.contains('is-open')) {
          menu.hidden = true;
          overlay.hidden = true;
        }
      }, 300);
    }

    function toggleSearch(forceOpen) {
      if (!searchPanel) return;
      var willOpen = forceOpen !== undefined ? forceOpen : searchPanel.hidden;
      searchPanel.hidden = !willOpen;
      qsa('[data-lh-search-toggle]').forEach(function (btn) { btn.setAttribute('aria-expanded', String(willOpen)); });
      if (willOpen) {
        var input = qs('input[type="search"]', searchPanel);
        if (input) input.focus();
      }
    }

    qsa('[data-lh-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', openMenu);
    });
    qsa('[data-lh-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });
    if (overlay) overlay.addEventListener('click', closeMenu);

    qsa('[data-lh-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (menu && menu.classList.contains('is-open')) closeMenu();
        toggleSearch();
      });
    });

    qsa('[data-lh-accordion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        btn.setAttribute('aria-expanded', String(!expanded));
        var icon = qs('[data-lh-accordion-icon]', btn);
        if (icon) icon.textContent = expanded ? '+' : '−';
        if (panel) panel.hidden = expanded;
      });
    });

    var megaItems = qsa('[data-lh-nav-dropdown]');
    var megaOpenDelay = 150;
    var megaCloseDelay = 250;
    var megaTimer = null;

    function closeMega(item) {
      item.classList.remove('is-open');
      var trigger = qs(':scope > a', item);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAllMegas(except) {
      megaItems.forEach(function (item) {
        if (item !== except) closeMega(item);
      });
    }

    function openMega(item) {
      closeAllMegas(item);
      item.classList.add('is-open');
      var trigger = qs(':scope > a', item);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    megaItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(megaTimer);
        megaTimer = setTimeout(function () { openMega(item); }, megaOpenDelay);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(megaTimer);
        megaTimer = setTimeout(function () { closeMega(item); }, megaCloseDelay);
      });
      item.addEventListener('focusin', function () {
        clearTimeout(megaTimer);
        openMega(item);
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMega(item);
      });
    });

    // Refined mega menu (>= 990px, any input): the promo panel follows the hovered/focused/tapped
    // designer when that link carries data-lh-follow-src. Images load on first hover/focus; opening the
    // dropdown preloads the first few. Never cancels a click, so a tap navigates on the first tap.
    // Inert when .lh-nav--refined is removed (rollback switch).
    if (qs('.lh-nav--refined') && window.matchMedia('(min-width: 990px)').matches) {
      // Touch/pen: a tap clears :hover on release and its focus is not :focus-visible, so mark the
      // pressed link with .is-tapped (styled like hover) until the next press or a back/forward return.
      var refinedLinks = qsa('.lh-nav--refined .lh-mega__link');
      function clearTapped() {
        refinedLinks.forEach(function (el) { el.classList.remove('is-tapped'); });
      }
      document.addEventListener('pointerdown', function (e) {
        clearTapped();
        if (e.pointerType === 'mouse') return;
        var link = e.target.closest && e.target.closest('.lh-nav--refined .lh-mega__link');
        if (link) link.classList.add('is-tapped');
      }, { passive: true });
      window.addEventListener('pageshow', clearTapped);

      qsa('.lh-nav--refined [data-lh-mega-follow]').forEach(function (mega) {
        var columns = qs('.lh-mega__columns', mega);
        var media = qs('[data-lh-promo-media]', mega);
        var caption = qs('[data-lh-promo-caption]', mega);
        var btn = qs('[data-lh-promo-btn]', mega);
        if (!columns || !media) return;

        var defaultCaption = caption ? caption.textContent : '';
        var defaultHref = btn ? btn.getAttribute('href') : '';
        var followLinks = qsa('a[data-lh-follow-src]', columns);
        var current = null;

        function layerFor(link) {
          if (link._lhLayer) return link._lhLayer;
          var img = document.createElement('img');
          img.className = 'lh-mega__promo-alt';
          img.alt = '';
          img.width = 300;
          img.height = 400;
          img.decoding = 'async';
          img.sizes = '280px';
          img.srcset = link.getAttribute('data-lh-follow-srcset');
          img.src = link.getAttribute('data-lh-follow-src');
          img.addEventListener('error', function () { link._lhBroken = true; img.remove(); });
          media.appendChild(img);
          link._lhLayer = img;
          return img;
        }

        function setPanel(link) {
          current = link;
          qsa('.lh-mega__promo-alt.is-active', media).forEach(function (el) {
            if (!link || el !== link._lhLayer) el.classList.remove('is-active');
          });
          if (!link) {
            if (caption) caption.textContent = defaultCaption;
            if (btn) btn.setAttribute('href', defaultHref);
            return;
          }
          var img = layerFor(link);
          function reveal() {
            if (current !== link || link._lhBroken) return;
            img.classList.add('is-active');
            if (caption) caption.textContent = link.textContent.trim();
            if (btn) btn.setAttribute('href', link.getAttribute('href'));
          }
          if (img.complete && img.naturalWidth) reveal();
          else img.addEventListener('load', reveal, { once: true });
        }

        function follow(link) {
          setPanel(link && link.hasAttribute('data-lh-follow-src') && !link._lhBroken ? link : null);
        }

        function onEnter(e) {
          var link = e.target.closest && e.target.closest('.lh-mega__link');
          if (!link || !columns.contains(link)) return;
          follow(link);
        }

        columns.addEventListener('pointerdown', onEnter);
        columns.addEventListener('mouseover', onEnter);
        columns.addEventListener('focusin', onEnter);
        // A tap fires mouseleave on release while its link keeps focus: fall back to the focused link.
        columns.addEventListener('mouseleave', function () {
          var focused = document.activeElement;
          follow(columns.contains(focused) ? focused.closest('.lh-mega__link') : null);
        });
        columns.addEventListener('focusout', function (e) {
          if (!columns.contains(e.relatedTarget)) setPanel(null);
        });

        var item = mega.closest('[data-lh-nav-dropdown]');
        if (item) {
          item.addEventListener('mouseenter', function () {
            followLinks.slice(0, 3).forEach(layerFor);
          }, { once: true });
        }
      });
    }

    var currencyWrap = qs('[data-lh-currency]');
    var currencyToggle = qs('[data-lh-currency-toggle]');
    var currencyList = qs('[data-lh-currency-list]');
    var currencyInput = qs('[data-lh-currency-input]');

    function closeCurrencyList() {
      if (!currencyList || currencyList.hidden) return;
      currencyList.hidden = true;
      if (currencyToggle) currencyToggle.setAttribute('aria-expanded', 'false');
    }

    if (currencyWrap && currencyToggle && currencyList && currencyInput) {
      currencyToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = currencyList.hidden;
        currencyList.hidden = !willOpen;
        currencyToggle.setAttribute('aria-expanded', String(willOpen));
      });

      qsa('[data-lh-currency-option]', currencyList).forEach(function (option) {
        option.addEventListener('click', function (e) {
          e.preventDefault();
          currencyInput.value = option.getAttribute('data-value');
          currencyInput.form.submit();
        });
      });
    }

    document.addEventListener('click', function (e) {
      megaItems.forEach(function (item) {
        if (!item.contains(e.target)) closeMega(item);
      });
      if (currencyWrap && !currencyWrap.contains(e.target)) closeCurrencyList();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeMenu();
        toggleSearch(false);
        closeAllMegas();
        closeCurrencyList();
      }
    });

    function setupFixedBar(sentinelSelector, barSelector, spacerSelector, fixedClass) {
      var sentinel = qs(sentinelSelector);
      var bar = qs(barSelector);
      var spacer = qs(spacerSelector);
      if (!sentinel || !bar || !spacer || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var stuck = !entry.isIntersecting;
          if (stuck) {
            // Measure while the bar is still in normal flow, before switching it to
            // fixed and removing it from flow — offsetHeight taken after that point
            // would still be correct here, but measuring first is the safe,
            // always-correct order and costs nothing.
            var barHeight = bar.offsetHeight;
            spacer.style.height = barHeight + 'px';
            spacer.style.display = 'block';
            bar.classList.add(fixedClass);
          } else {
            bar.classList.remove(fixedClass);
            spacer.style.display = 'none';
            spacer.style.height = '0';
          }
          bar.classList.toggle('is-stuck', stuck);
        });
      }, { threshold: 0 });
      observer.observe(sentinel);
    }
    setupFixedBar('[data-lh-sticky-sentinel="desktop"]', '.lh-nav', '[data-lh-nav-spacer]', 'lh-nav--fixed');
    setupFixedBar('[data-lh-sticky-sentinel="mobile"]', '.lh-mobile-sticky', '[data-lh-mobile-spacer]', 'lh-mobile-sticky--fixed');
  })();

  (function () {
    // Mirrors the generic #currency wiring in layout/theme.liquid (prettyDropdown
    // init + cookie sync) and assets/app.js.liquid (change -> write cookie + reload)
    // for the mobile-drawer duplicate at #currency-mobile — a second element needs
    // its own id since ids must be unique, so it needs this small copy of that
    // same logic. Runs on DOMContentLoaded so Currency (loaded via plain <script>
    // tags near the bottom of layout/theme.liquid) is guaranteed to already exist.
    function wireMobileCurrency() {
      var mobileCurrency = document.getElementById('currency-mobile');
      if (!mobileCurrency || typeof jQuery === 'undefined') return;

      if (typeof Currency !== 'undefined') {
        mobileCurrency.value = Currency.cookie.read() || '{{ shop.currency }}';
      }

      jQuery(mobileCurrency).prettyDropdown({ afterLoad: function () {} });

      jQuery(mobileCurrency).on('change', function () {
        if (typeof Currency !== 'undefined') {
          Currency.cookie.write(this.value);
        }
        window.location.reload();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireMobileCurrency);
    } else {
      wireMobileCurrency();
    }
  })();

  (function () {
    var AUTO_ROTATE_MS = 5000;
    var slideshow = document.querySelector('[data-lh-utility-slideshow]');
    if (!slideshow) return;

    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.lh-utility-slide'));
    // Also doubles as the autoplay-pause condition: with 0-1 slides there's
    // nothing to rotate to, same as why the arrows are hidden in the markup.
    if (slides.length < 2) return;

    var activeIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (activeIndex === -1) activeIndex = 0;

    var autoRotateTimer = null;

    function showSlide(nextIndex) {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides[activeIndex].classList.add('is-active');
    }

    function startAutoRotate() {
      // clearInterval on a stale id is a no-op, so this is always safe — it's
      // what lets restarting the timer (on manual click) and the initial
      // start share one function without ever stacking multiple intervals.
      clearInterval(autoRotateTimer);
      autoRotateTimer = setInterval(function () {
        showSlide(activeIndex + 1);
      }, AUTO_ROTATE_MS);
    }

    function goToSlide(nextIndex) {
      showSlide(nextIndex);
      startAutoRotate(); // manual pick resets the countdown, not just jumps the slide
    }

    var prevBtn = slideshow.querySelector('[data-lh-utility-prev]');
    var nextBtn = slideshow.querySelector('[data-lh-utility-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(activeIndex + 1); });

    startAutoRotate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-home-product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
    function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

    qsa('[data-lhps-next]').forEach(function (btn) {
      var wrap = btn.closest('.lhps__row-wrap');
      var row = wrap ? qs('[data-lhps-row]', wrap) : null;
      if (!row) return;

      btn.addEventListener('click', function () {
        var card = qs('.lhps__card', row);
        var cardWidth = card ? card.getBoundingClientRect().width : row.clientWidth;
        var rowStyles = window.getComputedStyle(row);
        var gap = parseFloat(rowStyles.columnGap || rowStyles.gap) || 0;
        row.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
      });
    });

    // Mouse click-and-drag scrolling for the row (desktop). A movement threshold
    // distinguishes "dragging the row" from "clicking a product" — under the
    // threshold, the click passes through and navigates normally.
    qsa('[data-lhps-row]').forEach(function (row) {
      var DRAG_THRESHOLD = 5;
      var isDown = false;
      var dragged = false;
      var startX = 0;
      var scrollStart = 0;

      row.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        startX = e.pageX;
        scrollStart = row.scrollLeft;
        row.classList.add('is-dragging');
        e.preventDefault(); // avoid native text/image drag ghosting while dragging
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (!dragged && Math.abs(dx) > DRAG_THRESHOLD) {
          dragged = true;
        }
        if (dragged) {
          row.scrollLeft = scrollStart - dx;
        }
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        row.classList.remove('is-dragging');
        if (dragged) {
          // Swallow the click that would otherwise fire on whatever is under the cursor
          row.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
          }, { capture: true, once: true });
        }
      });
    });

    // Per-card swipe to reveal the second product image on touch devices, where
    // :hover has no equivalent. Separate from the row's own horizontal scroll —
    // only claims the gesture once movement is clearly horizontal, so a normal
    // vertical page scroll or a row-scroll swipe starting elsewhere is unaffected.
    qsa('.lhps__image-wrap').forEach(function (wrap) {
      var secondary = qs('.lhps__image--secondary', wrap);
      var link = qs('.lhps__image-link', wrap);
      if (!secondary || !link) return; // single-image product — no swipe behavior

      var SWIPE_THRESHOLD = 40;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var isHorizontalSwipe = false;
      var didSwipe = false;

      wrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
        isHorizontalSwipe = false;
      }, { passive: true });

      wrap.addEventListener('touchmove', function (e) {
        if (!tracking || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        var absDx = Math.abs(dx);
        var absDy = Math.abs(dy);
        // Re-evaluated on every touchmove (never latched) against the total
        // distance since touchstart — a gesture that starts horizontal-ish but
        // turns vertical partway through must stop claiming the touch, or it
        // blocks the page's native vertical scroll for the rest of that
        // gesture. MIN_DISTANCE ignores touch jitter right at the start;
        // RATIO (1.5x) requires movement to be clearly horizontal, not just
        // barely more horizontal than vertical, before we claim it.
        var MIN_DISTANCE = 6;
        var RATIO = 1.5;
        isHorizontalSwipe = absDx > MIN_DISTANCE && absDx > absDy * RATIO;
        if (isHorizontalSwipe) {
          // Claim the gesture: block the row's native scroll from also engaging.
          e.preventDefault();
        }
      }, { passive: false });

      wrap.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        if (!isHorizontalSwipe) return;
        var endX = e.changedTouches.length ? e.changedTouches[0].clientX : startX;
        var dx = endX - startX;
        if (Math.abs(dx) >= SWIPE_THRESHOLD) {
          if (dx < 0) {
            wrap.classList.add('is-swiped');
          } else {
            wrap.classList.remove('is-swiped');
          }
          didSwipe = true;
          e.preventDefault(); // suppress the synthetic click that would otherwise navigate
        }
      });

      link.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-magazine-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
    function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

    // ---- Reader mode: lazy-loaded page-flip (StPageFlip, MIT, jsdelivr) ----
    // Only fetched the first time "Read the Issue" is clicked, so visitors who
    // never open the reader never pay for this library's JS/CSS.
    var PAGEFLIP_JS = 'https://cdn.jsdelivr.net/npm/page-flip@2.0.7/dist/js/page-flip.browser.min.js';
    var PAGEFLIP_CSS = 'https://cdn.jsdelivr.net/npm/page-flip@2.0.7/src/Style/stPageFlip.min.css';
    var pageFlipInstance = null;
    var loadingPromise = null;

    function loadPageFlipAssets() {
      if (loadingPromise) return loadingPromise;
      loadingPromise = new Promise(function (resolve, reject) {
        if (window.St && window.St.PageFlip) { resolve(); return; }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = PAGEFLIP_CSS;
        document.head.appendChild(link);

        var script = document.createElement('script');
        script.src = PAGEFLIP_JS;
        script.onload = function () { resolve(); };
        script.onerror = function () { reject(new Error('page-flip failed to load')); };
        document.head.appendChild(script);
      });
      return loadingPromise;
    }

    function initReader(reader) {
      var book = qs('#LuxuryMagazineBook', reader);
      if (!book || pageFlipInstance) return;

      var pages = qsa('.lmr__page', book);
      pageFlipInstance = new window.St.PageFlip(book, {
        // 360x640 = 9:16, matching the 1080x1920 export size given to merchants
        // for cover/back-cover/article page artwork.
        width: 360,
        height: 640,
        size: 'stretch',
        minWidth: 220,
        maxWidth: 420,
        minHeight: 391,
        maxHeight: 748,
        showCover: true,
        usePortrait: true,
        maxShadowOpacity: 0.35,
        flippingTime: 800,
        mobileScrollSupport: false
      });
      pageFlipInstance.loadFromHTML(pages);
    }

    // Waits for every <img> inside `container` to finish loading AND decoding
    // (decode() catches the case where the browser would otherwise do that
    // decode work on first paint — exactly the moment a flip reveals the
    // page — which is what caused the flash even with loading="eager").
    // img.decode() also implicitly waits for the fetch itself if it hasn't
    // started yet, so this covers both "still downloading" and "downloaded
    // but not yet decoded". Races against a timeout so one broken/slow image
    // (or a browser without decode() support falling back to load/error
    // listeners) can never block the reader open indefinitely.
    function preloadImages(container, timeoutMs) {
      var imgs = qsa('img', container);
      if (!imgs.length) return Promise.resolve();

      var promises = imgs.map(function (img) {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
        if (typeof img.decode === 'function') {
          return img.decode().catch(function () {}); // broken image — don't block on it
        }
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      });

      var timeout = new Promise(function (resolve) { setTimeout(resolve, timeoutMs); });
      return Promise.race([Promise.all(promises), timeout]);
    }

    function openReader() {
      var reader = qs('[data-lmr]');
      if (!reader) return;
      reader.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      if (pageFlipInstance) return; // already initialized on a previous open — images are ready

      var loadingOverlay = qs('[data-lmr-loading]', reader);
      var book = qs('#LuxuryMagazineBook', reader);
      if (loadingOverlay) loadingOverlay.hidden = false;

      var imagesReady = book ? preloadImages(book, 8000) : Promise.resolve();

      Promise.all([loadPageFlipAssets(), imagesReady]).then(function () {
        initReader(reader);
      }).catch(function (err) {
        if (window.console) console.error(err);
      }).then(function () {
        if (loadingOverlay) loadingOverlay.hidden = true;
      });
    }

    function closeReader() {
      var reader = qs('[data-lmr]');
      if (!reader) return;
      reader.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    qsa('[data-lm-open-reader]').forEach(function (btn) {
      btn.addEventListener('click', openReader);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-lmr-close]')) closeReader();
      if (e.target.closest('[data-lmr-prev]') && pageFlipInstance) pageFlipInstance.flipPrev();
      if (e.target.closest('[data-lmr-next]') && pageFlipInstance) pageFlipInstance.flipNext();
    });

    document.addEventListener('keydown', function (e) {
      var reader = qs('[data-lmr]');
      if (!reader || reader.hidden) return;
      if (e.key === 'Escape') closeReader();
      if (e.key === 'ArrowLeft' && pageFlipInstance) pageFlipInstance.flipPrev();
      if (e.key === 'ArrowRight' && pageFlipInstance) pageFlipInstance.flipNext();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-mobile-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

    qsa('[data-lmv]').forEach(function (wrap) {
      var video = wrap.querySelector('.lmv__media');
      var button = wrap.querySelector('[data-lmv-sound]');
      if (!video || !button || video.tagName !== 'VIDEO') return;

      var mutedIcon = button.querySelector('.lmv__sound-icon--muted');
      var unmutedIcon = button.querySelector('.lmv__sound-icon--unmuted');

      // Icon always reflects the video's CURRENT state (speaker-with-waves
      // when sound is on, crossed-out speaker when off) — the same
      // convention YouTube/Instagram/TikTok use. aria-label instead states
      // the ACTION the button performs, per standard toggle-button practice.
      function render() {
        mutedIcon.classList.toggle('is-active', video.muted);
        unmutedIcon.classList.toggle('is-active', !video.muted);
        button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }

      button.addEventListener('click', function () {
        video.muted = !video.muted;
        render();
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-pdp"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var openBtn      = document.getElementById('lpdpOpenModal');
  var modal        = document.getElementById('lpdpModal');
  var backdrop     = document.getElementById('lpdpModalBackdrop');
  var closeBtn     = document.getElementById('lpdpModalClose');
  var modalBody    = document.getElementById('lpdpModalBody');
  var formWrap     = document.getElementById('lpdpFormWrap');
  if (!formWrap) return;

  var formHome        = formWrap.parentNode;
  var formHomeNextSib = formWrap.nextSibling;

  function isMobile(){ return window.innerWidth < 768; }

  function openModal(){
    if (!isMobile()) return;
    formWrap.classList.add('lpdp-in-modal');
    modalBody.appendChild(formWrap);
    modal.classList.add('is-open');
    document.body.classList.add('lpdp-modal-lock');
  }
  function closeModal(){
    formWrap.classList.remove('lpdp-in-modal');
    if (formHomeNextSib) {
      formHome.insertBefore(formWrap, formHomeNextSib);
    } else {
      formHome.appendChild(formWrap);
    }
    modal.classList.remove('is-open');
    document.body.classList.remove('lpdp-modal-lock');
  }

  if (openBtn)  openBtn.addEventListener('click', openModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  // Keep the summary button label in sync with the currently chosen color/size
  function updateSummaryLabel(){
    var parts = [];
    var colorInput = document.querySelector('#spell1 input[type="hidden"]');
    var sizeInput  = document.querySelector('.product-info-size input[type="hidden"]');
    if (colorInput && colorInput.value) parts.push(colorInput.value);
    if (sizeInput && sizeInput.value) parts.push(sizeInput.value);
    if (openBtn) {
      openBtn.querySelector('.lpdp-mobile-summary-label').textContent = parts.length ? parts.join(' / ') : 'Color & Size';
    }
  }
  // Keep the mobile gallery (and its dot nav) in sync with whichever image
  // product_form.js just made active in the desktop slideshow. Matched by
  // index since UIkit's dot <li> elements are auto-generated and carry no
  // src of their own — our manual class toggle bypasses UIkit's own slide
  // tracking, so its automatic dot sync no longer applies here either.
  function syncMobileGalleryToDesktop(){
    var activeDesktopImg = document.querySelector('.lpdp-main-list > li.uk-active img');
    if (!activeDesktopImg) return;
    var targetSrc = activeDesktopImg.getAttribute('src');
    var mobileItems = document.querySelectorAll('.lpdp-mobile-list > li');
    var activeIndex = -1;
    mobileItems.forEach(function(li, index){
      var img = li.querySelector('img');
      if (img && img.getAttribute('src') === targetSrc) {
        li.classList.add('uk-active');
        activeIndex = index;
      } else {
        li.classList.remove('uk-active');
      }
    });

    if (activeIndex > -1) {
      var dotItems = document.querySelectorAll('.lpdp-dots > li');
      dotItems.forEach(function(dot, index){
        if (index === activeIndex) {
          dot.classList.add('uk-active');
        } else {
          dot.classList.remove('uk-active');
        }
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('option-button') || e.target.classList.contains('option-button1') || e.target.classList.contains('opimg')) {
      setTimeout(updateSummaryLabel, 60);
      setTimeout(syncMobileGalleryToDesktop, 380);
    }
  });
  updateSummaryLabel();

  // Reset modal state on resize back to desktop so form isn't stranded inside the modal DOM
  window.addEventListener('resize', function () {
    if (!isMobile() && formWrap.classList.contains('lpdp-in-modal')) {
      closeModal();
    }
  });

  // Tab bar (single active panel — was a multi-open accordion toggle)
  var lpdpAccItems = document.querySelectorAll('.lpdp-accordion > .lpdp-acc-item');
  document.querySelectorAll('.lpdp-acc-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      lpdpAccItems.forEach(function (item) { item.classList.remove('is-open'); });
      btn.closest('.lpdp-acc-item').classList.add('is-open');
    });
  });

  // Size dropdown — a pure-UI <select> that proxies to the existing hidden
  // .option-button elements so product_form.liquid's tested variant-matching
  // logic never has to change. Selecting a value clicks the matching button;
  // the reverse sync (button -> select) covers the case where product_form's
  // own JS auto-clicks a different size button after a color change.
  var lpdpSizeSelect = document.querySelector('.lpdp-size-select');
  if (lpdpSizeSelect) {
    lpdpSizeSelect.addEventListener('change', function () {
      var btn = document.querySelector('.product-info-size .option-button[data-val="' + this.value + '"]');
      if (btn) { btn.click(); }
    });
  }
  document.querySelectorAll('.product-info-size .option-button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (lpdpSizeSelect) { lpdpSizeSelect.value = this.getAttribute('data-val'); }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
